export class AppConfig {
  apiUri: string;
  adminApiUrl: string;
  insuredApiUrl: string;
  waiverApiUrl: string;
  srUniteUrl: string;
  supportEmail: string = "PartnerCenterSupport@uhcsr.com";
  aboutUs_guid: string = "f6b1a490-bfd9-4d5d-a64d-9840c3c9757f";
  contactUs_guid: string = "2332113c-cc54-4ffd-8cf1-3227305374e8";
  claimsApiUrl: string;
  termsOfUse_guid: string;
  termsOfUse_content_link: string = "https://www.uhc.com/content/dam/uhcdotcom/en/npp/TOU-UHC-PC-StudentResources-EN.pdf";
  wPP_content_link: string = "https://www.uhc.com/content/dam/uhcdotcom/en/npp/WPP-UHC-PC-StudentResources-EN.pdf";
  privacyPolicy_guid: string = "ba3fca2a-c06c-4d25-b36d-c47aaa74e5bb";
  additionalBenefitsGuids:any = new AdditionalBenefitsGuids;
  cmsImageUrl: string;
  cmsAssetUrl: string;
  partnerCenterOldUrl: string;
  forgotUserNameUrl: string = "default.aspx?action = forgotusername";
  forgotPasswordUrl: string = "default.aspx?action=forgotpassword";
  menuUrls:any = new MenuUrls;
  azmanRoles: Array<string> = [
    "rEmail Communications Client Admin",
    "rEmail Communications Internal Admin",
    "rEmail Communications View Only",
    "rInsurance Management Client Admin - Edit",
    "rInsurance Management Client Admin - View Only",
    "rInsurance Management Internal Admin",
    "rInsurance Management SHC Admin - Edit",
    "rInsurance Management SHC Admin - View Only",
    "rInsurance Management View Only",
    "rLedger Billing Client Admin",
    "rLedger Billing Internal Admin",
    "rLedger Billing View Only",
    "rPayment Management Internal Admin",
    "rPayment Management School User",
    "rPayment Management School User with Edit Date",
    "rPayment Management View Only",
    "rReferrals Client Admin",
    "rReferrals Internal Admin",
    "rReferrals View Only",
    "rSchool Setup Internal Admin",
    "rSchool Setup View Only",
    "rUser Maintenance Internal Admin",
    "rUser Maintenance View Only",
    "rWaiver Management Client Admin",
    "rWaiver Management Internal Admin",
    "rWaiver Management Internal Verification Admin",
    "rWaiver Management View Only"
  ];;
  modules: Array<Module>;
  idp_AuthorizationUrl: string;
  idp_RedirectUrl: string;
  idp_ClientId: string = "PC000109N";
  idp_Scope: string = "openid+profile+email";
  old_idp_AuthorizationUrl: string;
  old_idp_ClientId: string = "SR.PartnerCenter.Secure";
  old_idp_Scope: string = "openid PartnerAPI.Secure PartnerCenterLegacy.Secure PartnerAPI.Insurance PartnerAPI.Waiver";
  idp_UserInfoUrl: string = "connect/userinfo";
  idp_PostlogoutRedirectUri: string;
  idp_SilentRedirectUri: string;
  idp_SilentTimeout: number = 60000;
  myaccount_RedirectUri: string;
  myaccount_idp_scope: string = "openid MyAccountApi.Secure";
  myaccount_cookie_key: string;
  user_Session_Timeout: number = 20;
  pc_storage_key: string = "currentUser";
  currentUser_env: string;
  customerServiceinfo: string;
  currentClientKey: string = "currentClient";
  encryptedRolesKey: string = "encryptedRoles";
  splunkUrl: string;
  splunkApplicationName: string;
  enableDebugSplunkLogging: string;
  insured_Label_ClientNum: number = 1863;
  timeZone: string = "UTC-5";
  oidc_user: string = "oidc.user:";
  is_User_ActiveInPC: string = "isUserActiveInPC";
  hsid_pfidpadapterid: string;
  hsid_client_id: string;
  hsid_myaccount_uri: string;
  hsid_scope: string = "openid+profile";
  hsid_portal: string = "UHCSR";
  hsid_impersonation_url: string;
  myaccount_signout_timeout: number = 12000;
  redirect_to_myaccount_delay: number = 10000;
}

export class AdditionalBenefitsGuids {
  MainGuid: string = "2e44b9c3-9d99-11ed-9d6f-0050568b02a7";
  TelehealthMedicalGuid: string = "2e44ad11-9d99-11ed-9d6f-0050568b02a7";
  TelehealthBehavioralGuid: string = "2e44a4d1-9d99-11ed-9d6f-0050568b02a7";
  TelehealthBehavioralHYBHGuid: string = "ab7578f4-d6a5-42a6-82f0-45c97f8744d0";
  StudentAssistanceProgramGuid: string = "2e44a5aa-9d99-11ed-9d6f-0050568b02a7";
  NurseLineGuid: string = "2e44a67e-9d99-11ed-9d6f-0050568b02a7";
  TravelAssistanceServicesGuid: string = "2e44a67e-9d99-11ed-9d6f-0050568b02a7";
  HealthAlliesDiscountGuid: string = "2e44a8d1-9d99-11ed-9d6f-0050568b02a7";
}

export class MenuUrls {
  usersUrl: string = "Secure/OtherResources/Users/UserHome.aspx";
  setupFeaturesUrl: string = "Secure/OtherResources/ClientConfiguration/SchoolFeatures.aspx";
  myProfileUrl: string = "Secure/OtherResources/MyProfile.aspx";
  reportsUrl: string = "Secure/OtherResources/Reports/ReportsHome.aspx";
}

export class Module {
  description: string;
  url: string;
  blockName: string;
  isDisabled: boolean;
  blocks: Array<Module>;
  transform = true;
  default: string;
  isEnrollmentRequired: Boolean;
  isEarlyEnrollment = true;
  isEmailNotificationEnabled: Boolean;
  isAccessible: Boolean;
  permission: string;
  moduleName?: any;
  order: number;
}

export class ClientsList {
  AllClients?: any;
  WaiverManagement?: any;
  ClaimsManagement?: any;
  InsuranceManagement?: any;
  PaymentManagement?: any;
  ManageReferrals?: any;
  ManageSHCBilling?: any;
  SchoolSetup?: any;
}


